const initialState = {
  isFetching: false,
  isSuccess: false,
  withdrawalMessageText: null
}

export const ACTION_TYPES = {
  WITHDRAWAL_MESSAGE_REQUEST: 'WITHDRAWAL_MESSAGE_REQUEST',
  WITHDRAWAL_MESSAGE_SUCCESS: 'WITHDRAWAL_MESSAGE_SUCCESS',
  WITHDRAWAL_MESSAGE_ERROR: 'WITHDRAWAL_MESSAGE_ERROR'
}

export const getWithdrawalMessage = (type, text) => ({
  type: ACTION_TYPES.WITHDRAWAL_MESSAGE_REQUEST,
  payload: { type, text }
})

const withdrawalMessage = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.WITHDRAWAL_MESSAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
        isSuccess: false
      }
    case ACTION_TYPES.WITHDRAWAL_MESSAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        withdrawalMessageText: payload
      }
    case ACTION_TYPES.WITHDRAWAL_MESSAGE_ERROR:
      return {
        ...state,
        isFetching: false,
        isSuccess: false,
        withdrawalMessageText: null
      }
    default:
      return state
  }
}

export default withdrawalMessage
